import classNames from "classnames";
import { FC, useEffect, useState } from "react";

type ShareIconProps = {
  urlPrefix: string;
  className?: string | string[];
};

const ShareIcon: FC<ShareIconProps> = ({ urlPrefix, className, children }) => {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    setCurrentUrl(window.location.href);
  });

  return (
    <div className={classNames(className)}>
      <a
        href={`${urlPrefix}${encodeURIComponent(currentUrl)}`}
        target="_blank"
        rel="noreferrer"
      >
        {children}
      </a>
    </div>
  );
};

export default ShareIcon;
